var path = window.location.pathname;
if (path === "/collections" || path === "/collections/") {
    window.location.href = "/collections/all";
}

(function () {
  var ATTRIBUTE_KEY = 'device';

  function getScreenSize() {
    if (window.screen.width < 1000) {
      return 'mobile-true';
    } else {
      return 'mobile-false';
    }
  }

  function updateCartAttribute() {
    var value = getScreenSize();

    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/update.js', true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('Accept', 'application/json');

    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (xhr.status >= 200 && xhr.status < 300) {
          try {
            var cart = JSON.parse(xhr.responseText);
            console.log('Cart attribute "' + ATTRIBUTE_KEY + '" updated:', cart.attributes[ATTRIBUTE_KEY]);
          } catch (e) {
            console.error('Error parsing response:', e);
          }
        } else {
          console.error('Failed to update cart attribute. Status:', xhr.status);
        }
      }
    };

    xhr.onerror = function () {
      console.error('Network error while updating cart attribute');
    };

    xhr.send(JSON.stringify({
      attributes: {
        device: value
      }
    }));
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateCartAttribute);
  } else {
    updateCartAttribute();
  }

  // Update on window resize (with debounce)
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateCartAttribute, 300);
  });
})();